/**
 * Note the code in this file was cobbled together from the
 * original old version of the site (from around 2010) and
 * converted to Typescript without any major refactoring.
 */ class $7226e80cfe4a2bc7$export$2e2bcd8739ae039 {
    constructor(){
        this.listeners = {};
        this.on = (event, listener)=>{
            this.listeners[event] = [
                ...this.listeners[event] ?? [],
                listener
            ];
            return {
                dispose: ()=>{
                    this.off(event, listener);
                }
            };
        };
        this.off = (event, listener)=>{
            const callbackIndex = this.listeners[event]?.indexOf(listener) ?? -1;
            if (callbackIndex > -1) this.listeners[event]?.splice(callbackIndex, 1);
        };
        this.emit = (event, // Workaround to make the argument optional if the event property is undefined
        ...payload)=>this.listeners[event]?.forEach((listener)=>listener(payload[0]));
    }
}


const $04727a7494007a54$var$getIdFromYoutubeUrl = (url)=>{
    const re = /^(https?:\/\/)?((www\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i;
    return url.match(re)?.[7];
};
class $04727a7494007a54$export$2e2bcd8739ae039 {
    constructor(){
        this.playheadInterval = 0;
        this.endSeconds = null;
        this.playerReady = false;
        this.ytPlayer = null;
        ///////////////////////////////
        //           EVENTS
        ///////////////////////////////
        this.onPlayerError = (event)=>{
            this.emitter.emit('error', {
                event: event
            });
        };
        this.onPlayerReady = (event)=>{
            console.log('Player is ready');
            this.playerReady = true;
            this.ytPlayer = event.target;
            this.emitter.emit('ready', {
                event: event
            });
        };
        this.onPlayerStateChange = (event)=>{
            switch(event.data){
                case YT.PlayerState.PLAYING:
                    console.log("Player state change: playing");
                    this.startPlayhead();
                    this.emitter.emit('playing', {
                        event: event
                    });
                    break;
                case YT.PlayerState.ENDED:
                    console.log("Player state change: ended");
                    this.stopPlayhead();
                    this.emitter.emit('ended', {
                        event: event
                    });
                    break;
                case YT.PlayerState.PAUSED:
                    console.log("Player state change: paused");
                    this.stopPlayhead();
                    this.emitter.emit('paused', {
                        event: event
                    });
                    break;
                case YT.PlayerState.BUFFERING:
                    console.log("Player state change: buffering");
                    this.stopPlayhead();
                    this.emitter.emit('buffering', {
                        event: event
                    });
                    break;
                case YT.PlayerState.CUED:
                    console.log("Player state change: cued");
                    this.emitter.emit('cued', {
                        event: event
                    });
                    break;
                case YT.PlayerState.UNSTARTED:
                    console.log("Player state change: unstarted");
                default:
                    break;
            }
        };
        this.emitter = new (0, $7226e80cfe4a2bc7$export$2e2bcd8739ae039)();
        this.on = this.emitter.on;
        this.off = this.emitter.off;
    }
    ///////////////////////////////
    //          PLAYHEAD
    ///////////////////////////////
    startPlayhead() {
        this.playheadInterval = setInterval(this.updatePlayhead, 100);
    }
    stopPlayhead() {
        clearInterval(this.playheadInterval);
    }
    updatePlayhead() {
        if (typeof this.ytPlayer?.getCurrentTime() == 'undefined') {
            clearInterval(this.playheadInterval);
            return;
        }
        const playerCurrentTime = this.ytPlayer.getCurrentTime();
        if (this.endSeconds !== null && playerCurrentTime >= this.endSeconds) {
            this.endSeconds = null;
            this.stop();
        }
    }
    seekToPercent(percent) {
        const time = percent * (this.ytPlayer?.getDuration() ?? 0);
        this.ytPlayer?.seekTo(time, true);
    }
    ///////////////////////////////
    //       CORE FUNCTIONS
    ///////////////////////////////
    isReady() {
        return this.playerReady;
    }
    play(reset = false) {
        if (!this.isReady()) {
            this.on("ready", ()=>{
                this.play(reset);
            });
            return;
        }
        if (reset) this.ytPlayer?.seekTo(0, true);
        this.ytPlayer?.playVideo();
    }
    stop() {
        if (!this.isReady()) {
            this.on("ready", function() {
                stop();
            });
            return;
        }
        this.ytPlayer?.stopVideo();
    }
    pause() {
        if (!this.isReady()) {
            this.on("ready", ()=>{
                this.pause();
            });
            return;
        }
        this.ytPlayer?.pauseVideo();
    }
    unPause() {
        if (!this.isReady()) {
            this.on("ready", ()=>{
                this.unPause();
            });
            return;
        }
        this.ytPlayer?.playVideo();
    }
    togglePause() {
        if (!this.isReady()) return;
        if (this.isPaused()) this.ytPlayer?.playVideo();
        else this.ytPlayer?.pauseVideo();
    }
    isPaused() {
        if (!this.isReady()) return false;
        return this.getState() == YT.PlayerState.PAUSED;
    }
    isPlaying() {
        if (!this.isReady()) return false;
        return this.getState() == YT.PlayerState.PLAYING;
    }
    getState() {
        return this.ytPlayer?.getPlayerState() ?? YT.PlayerState.UNSTARTED;
    }
    cueVideoById(videoId, startSeconds, suggestedQuality) {
        if (!this.isReady()) {
            this.on("ready", ()=>{
                this.cueVideoById(videoId, startSeconds, suggestedQuality);
            });
            return;
        }
        this.ytPlayer?.cueVideoById(videoId, startSeconds, suggestedQuality);
    }
    cueVideoByUrl(videoUrl, startSeconds, suggestedQuality) {
        const id = $04727a7494007a54$var$getIdFromYoutubeUrl(videoUrl);
        if (!id) throw new Error('Failed to extract ID for videoUrl ' + videoUrl);
        this.cueVideoById(id, startSeconds, suggestedQuality);
    }
    loadVideoById(videoId, startSeconds, suggestedQuality) {
        console.log('loadVideoById', videoId, startSeconds, suggestedQuality);
        if (!this.isReady()) {
            console.log('Player is not ready');
            this.on("ready", ()=>{
                console.log('After ready triggered', videoId);
                this.loadVideoById(videoId, startSeconds, suggestedQuality);
            });
            return;
        }
        this.ytPlayer?.loadVideoById(videoId, startSeconds, suggestedQuality);
    }
    loadVideoByUrl(videoUrl, startSeconds, suggestedQuality) {
        const id = $04727a7494007a54$var$getIdFromYoutubeUrl(videoUrl);
        if (!id) throw new Error('Failed to extract ID for videoUrl ' + videoUrl);
        this.loadVideoById(id, startSeconds, suggestedQuality);
    }
    getCurrentTime() {
        return this.ytPlayer?.getCurrentTime() ?? 0;
    }
    getDuration() {
        return this.ytPlayer?.getDuration() ?? 0;
    }
    seekTo(seconds, allowSeekAhead) {
        this.ytPlayer?.seekTo(seconds, allowSeekAhead);
    }
    clearVideo() {
        this.ytPlayer?.stopVideo();
    }
    mute() {
        if (!this.isReady()) {
            this.on("ready", ()=>{
                this.mute();
            });
            return;
        }
        this.ytPlayer?.mute();
    }
    unMute() {
        if (!this.isReady()) {
            this.on("ready", ()=>{
                this.unMute();
            });
            return;
        }
        this.ytPlayer?.unMute();
    }
    isMuted() {
        return this.ytPlayer?.isMuted() ?? false;
    }
    toggleMute() {
        if (this.isMuted()) this.unMute();
        else this.mute();
    }
    setVolume(volume) {
        if (!this.isReady()) {
            this.on("ready", ()=>{
                this.setVolume(volume);
            });
            return;
        }
        this.ytPlayer?.setVolume(volume);
    }
    getVolume() {
        return this.ytPlayer?.getVolume() ?? 100;
    }
}


//const baseUrl = 'http://localhost:8787/api/data/' // Default local dev url of ../api project
const $ecd2f77a879a31aa$var$baseUrl = 'https://api.ragereplay.com/api/data/' // Must have trailing slash
;
let $ecd2f77a879a31aa$var$dataIndex = {
    playlists: []
};
const $ecd2f77a879a31aa$export$c0933877973da308 = async ()=>{
    if ($ecd2f77a879a31aa$var$dataIndex.playlists.length) return Promise.resolve($ecd2f77a879a31aa$var$dataIndex);
    const response = await fetch($ecd2f77a879a31aa$var$baseUrl + 'index.json');
    if (!response.ok) throw new Error(`Failed to load playlist index: ${response.statusText}`);
    const data = await response.json();
    $ecd2f77a879a31aa$var$dataIndex = data;
    return data;
};
const $ecd2f77a879a31aa$export$b9347112ad6b5fab = async (path)=>{
    const response = await fetch($ecd2f77a879a31aa$var$baseUrl + path);
    if (!response.ok) throw new Error(`Failed to load playlist ${path}: ${response.statusText}`);
    const data = await response.json();
    return data;
};


//const baseUrl = 'http://localhost:8787/api/' // Default local dev url of ../api project
const $7904131f2451c9a3$var$baseUrl = 'https://api.ragereplay.com/api/' // Must have trailing slash
;
const $7904131f2451c9a3$export$bd80cdd36f597791 = (artist, song)=>{
    return new Promise((resolve, reject)=>{
        $.ajax({
            method: 'GET',
            url: $7904131f2451c9a3$var$baseUrl + 'musicvideosearch',
            dataType: 'json',
            data: {
                artist: artist,
                song: song
            },
            success: (data)=>resolve(data),
            error: (_jqXHR, textStatus, errorThrown)=>{
                reject(textStatus + ': ' + errorThrown);
            }
        });
    });
};



class $a06e308a742a25e4$export$3748a2f1ceae9e24 {
    constructor(){
        this.pos = -1;
        this.sourcelist = [];
        this.emitter = new (0, $7226e80cfe4a2bc7$export$2e2bcd8739ae039)();
        this.on = this.emitter.on;
        this.off = this.emitter.off;
    }
    add(videoInfo) {
        this.sourcelist.push(videoInfo);
    }
    next() {
        if (!this.hasNext()) return null;
        this.pos++;
        this.emitter.emit('change');
        return this.sourcelist[this.pos];
    }
    prev() {
        if (!this.hasPrev()) return null;
        this.pos--;
        this.emitter.emit('change');
        return this.sourcelist[this.pos];
    }
    hasNext() {
        return this.pos < this.sourcelist.length - 1;
    }
    hasPrev() {
        return this.pos > 0;
    }
    seek(pos) {
        if (pos < 0 || pos > this.sourcelist.length) return;
        this.pos = pos;
        this.emitter.emit('change');
    }
    indexOf(sourceListItem) {
        return this.sourcelist.indexOf(sourceListItem);
    }
    current() {
        if (this.pos < 0) return null;
        return this.sourcelist[this.pos];
    }
    clear() {
        this.pos = -1;
        this.sourcelist = [];
        this.emitter.emit('cleared');
    }
    //sets the current source as invalid/error
    setCurrentError() {
        if (this.pos < 0) return;
        this.sourcelist[this.pos].error = true;
    }
    /**
   * Clears sources list and loads new sources from the API.
   * @param track PlaylistTrack
   */ async load(track) {
        this.clear();
        this.emitter.emit('loadBegin', {
            track: track
        });
        try {
            const sources = await (0, $7904131f2451c9a3$export$bd80cdd36f597791)(track.artist, track.song);
            sources.forEach((source)=>{
                this.add({
                    title: source.title ?? 'Unknown title',
                    url: source.url
                });
            });
            this.pos = 0;
            this.emitter.emit('change');
            this.emitter.emit('loadSuccess', {
                track: track
            });
        } catch (e) {
            this.emitter.emit('loadError', {
                track: track,
                error: e.message
            });
        }
    }
}



var $c712a71d8ed2163c$export$199631bfaacffce5 = /*#__PURE__*/ function(TrackChangeDirection) {
    TrackChangeDirection[TrackChangeDirection["FORWARD"] = 1] = "FORWARD";
    TrackChangeDirection[TrackChangeDirection["BACKWARD"] = -1] = "BACKWARD";
    TrackChangeDirection[TrackChangeDirection["NONE"] = 0] = "NONE";
    return TrackChangeDirection;
}({});
class $c712a71d8ed2163c$export$8931430458a8a419 {
    constructor(){
        this.max = 1000 // the playlist will never grow bigger than this
        ;
        this.pos = -1;
        this.playlist = [];
        this.emitter = new (0, $7226e80cfe4a2bc7$export$2e2bcd8739ae039)();
        this.on = this.emitter.on;
        this.off = this.emitter.off;
    }
    // Adds track to end of the playlist
    // if the track param is an array then it will loop through and add each track
    add(track) {
        if (Array.isArray(track)) {
            track.forEach((t)=>this.add(t));
            return;
        }
        if (this.playlist.length >= this.max) {
            this.playlist.shift() // remove first item from playlist
            ;
            if (this.pos >= 0) this.pos--;
        }
        this.playlist.push(track);
        this.emitter.emit('modified');
    }
    // Removes track from the playlist
    // returns the removed track or null
    remove(track) {
        let index = this.playlist.indexOf(track);
        if (index != -1) {
            const track = this.playlist.splice(index, 1);
            if (this.pos > index && this.pos >= 0) this.pos--;
            this.emitter.emit('modified');
            return track[0];
        }
        return null;
    }
    // Returns the next track or null
    // updatePos: whether to automatically increment the playlist pos
    next(updatePos = true) {
        if (!this.hasNext()) {
            this.emitter.emit('finished');
            return null;
        }
        let result = this.playlist[this.pos + 1];
        if (updatePos == true) {
            this.pos++;
            this.emitter.emit('change', {
                current: this.playlist[this.pos],
                previous: this.playlist[this.pos - 1],
                direction: 1
            });
        }
        return result;
    }
    // Returns the prev track or null
    // updatePos: whether to automatically decrement the playlist pos
    prev(updatePos = true) {
        if (!this.hasPrev()) return null;
        let result = this.playlist[this.pos - 1];
        if (updatePos == true) {
            this.pos--;
            this.emitter.emit('change', {
                current: this.playlist[this.pos],
                previous: this.playlist[this.pos + 1],
                direction: -1
            });
        }
        return result;
    }
    hasNext() {
        return this.pos < this.playlist.length - 1;
    }
    hasPrev() {
        return this.pos > 0;
    }
    current() {
        if (this.pos < 0) return null;
        return this.playlist[this.pos];
    }
    rewind() {
        this.pos = 0;
        this.emitter.emit('change', {
            current: this.playlist[this.pos],
            previous: this.next(false),
            direction: -1
        });
        return this.playlist[this.pos];
    }
    fastForward() {
        this.pos = this.playlist.length - 1;
        this.emitter.emit('change', {
            current: this.playlist[this.pos],
            previous: this.prev(false),
            direction: 1
        });
        return this.playlist[this.pos];
    }
    skip(newPos) {
        if (typeof newPos == "undefined" || this.playlist[newPos] == undefined) {
            console.log("Tracklist.skip() Position is not valid. Ignoring...");
            return this.playlist[this.pos];
        }
        if (this.pos == newPos) return this.playlist[this.pos];
        let direction = 0;
        let secondaryTrack = null;
        if (newPos > this.pos) {
            direction = 1;
            secondaryTrack = this.next(false);
        } else {
            direction = -1;
            secondaryTrack = this.prev(false);
        }
        this.pos = newPos;
        this.emitter.emit('change', {
            current: this.playlist[this.pos],
            previous: secondaryTrack,
            direction: direction
        });
        return this.playlist[this.pos];
    }
    // Returns the size of the playlist
    length() {
        return this.playlist.length;
    }
    getPosition() {
        return this.pos;
    }
    // Returns how many tracks are yet to be played in the current playlist
    upcomingLength() {
        return this.playlist.length - 1 - this.pos;
    }
    // Clears all the next tracks from the playlist
    clearUpcoming() {
        this.playlist = this.playlist.slice(0, this.pos + 1);
        this.emitter.emit('modified');
    }
    // Clear track history
    clear() {
        this.playlist = [];
        this.pos = -1;
        this.emitter.emit('modified');
    }
}


const $5d5a5f1ec9489c77$export$324699496a105db8 = (rawStr)=>{
    return rawStr.replace(/[\u00A0-\u9999<>\&]/g, (i)=>{
        return '&#' + i.charCodeAt(0) + ';';
    });
};
const $5d5a5f1ec9489c77$export$a1a11b095f88289a = $5d5a5f1ec9489c77$export$324699496a105db8;


const $467385f7f475430f$var$formatSpecialTitle = (title)=>{
    const toReplace = [
        'guest programs rage',
        'guest program rage',
        'guest programs',
        'guest program',
        'Guest Programs',
        'Grust Program'
    ];
    toReplace.forEach((str)=>{
        title = title.replace(str, '');
    });
    return title.charAt(0).toUpperCase() + title.substring(1, 30).trim();
};
function $467385f7f475430f$export$2e2bcd8739ae039(_playlists) {
    const playlists = _playlists.slice().sort((a, b)=>(a.special ?? '').localeCompare(b.special ?? ''));
    const $el = $(document.createDocumentFragment());
    for (const playlist of playlists){
        if (!playlist.special || playlist.special.startsWith('New Music')) continue;
        const id = playlist.path.replace('.json', '');
        $el.append(`<p>
        <a href="#/episode/${(0, $5d5a5f1ec9489c77$export$a1a11b095f88289a)(id)}/1" class="playlist" data-playlist_id="${(0, $5d5a5f1ec9489c77$export$a1a11b095f88289a)(id)}">
          ${(0, $5d5a5f1ec9489c77$export$a1a11b095f88289a)($467385f7f475430f$var$formatSpecialTitle(playlist.special))}
        </a>
      </p>`);
    }
    return $el;
}


const $7f3216bf7640124b$export$ed7e01d08fb37999 = (number)=>{
    let selector;
    if (number <= 0) selector = 4;
    else if (number > 3 && number < 21 || number % 10 > 3) selector = 0;
    else selector = number % 10;
    return number + [
        'th',
        'st',
        'nd',
        'rd',
        ''
    ][selector];
};
const $7f3216bf7640124b$export$2061056d06d7cdf7 = (date)=>{
    const weekDays = [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ];
    return weekDays[date.getDay()];
};
const $7f3216bf7640124b$export$c1d85b1285963efe = (date)=>{
    const day = $7f3216bf7640124b$export$ed7e01d08fb37999(date.getDate());
    const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    return `${day} ${monthNames[date.getMonth()]}`;
};



function $534e17de79e7dddf$export$2e2bcd8739ae039(_playlists) {
    const playlists = _playlists.slice().reverse();
    const $el = $(document.createDocumentFragment());
    let prevYear = null;
    for (const playlist of playlists){
        const date = new Date(Date.parse(playlist.date));
        // @TODO - original code added one day to date if
        //         timeslot is morning, check if still required
        const year = date.getFullYear();
        if (prevYear != year) {
            $el.append(`
        <div class="clearfix"></div>
        <a name="episode-${year}"></a>
        <h2><span>${year}</span></h2>`);
            prevYear = year;
        }
        const id = playlist.path.replace('.json', '');
        $el.append(`<p>
        <a href="#/episode/${(0, $5d5a5f1ec9489c77$export$a1a11b095f88289a)(id)}/1"
           class="playlist"
           data-playlist_id="${(0, $5d5a5f1ec9489c77$export$a1a11b095f88289a)(id)}"
           ${playlist.special ? `rel="tooltip" title="${(0, $5d5a5f1ec9489c77$export$a1a11b095f88289a)(playlist.special)}" data-placement="top"` : ''}
        >
          <span style="color:#BBB; font-family:monospace;">${(0, $7f3216bf7640124b$export$2061056d06d7cdf7)(date)}</span>
          ${(0, $7f3216bf7640124b$export$c1d85b1285963efe)(date)}
          ${playlist.special ? '<span class="label label-info">s</span>' : ''}
        </a>
      </p>`);
    }
    return $el;
}


function $cc80b4a83a45e629$export$2e2bcd8739ae039() {
    const $el = $(document.createDocumentFragment());
    const startYear = 1999;
    const endYear = new Date().getFullYear();
    for(let year = startYear; year <= endYear; year++)$el.append(`<li><a class="skip-to-year" data-year="${year}" href="javascript:void(0)">${year}</a></li>`);
    return $el;
}


let $833ddd79a766fc37$var$currentPlaylist = null;
const $833ddd79a766fc37$var$trackList = new (0, $c712a71d8ed2163c$export$8931430458a8a419)();
const $833ddd79a766fc37$var$sourceList = new (0, $a06e308a742a25e4$export$3748a2f1ceae9e24)();
const $833ddd79a766fc37$var$player = new (0, $04727a7494007a54$export$2e2bcd8739ae039)();
window.onYouTubePlayerAPIReady = ()=>{
    new YT.Player('player', {
        height: '315',
        width: '560',
        videoId: 'ZzxKW6O8sNM',
        playerVars: {
            fs: 0,
            autoplay: 0,
            showinfo: 0,
            controls: 0,
            disablekb: 1,
            iv_load_policy: 3,
            modestbranding: 1,
            rel: 0,
            loop: 0
        },
        events: {
            onReady: $833ddd79a766fc37$var$player.onPlayerReady,
            onStateChange: $833ddd79a766fc37$var$player.onPlayerStateChange,
            onError: $833ddd79a766fc37$var$player.onPlayerError
        }
    });
};
const $833ddd79a766fc37$var$init = ()=>{
    // ROUTER
    const router = new Simrou({
        '/episode/top200': {
            get: ()=>{
                router.navigate(`/episode/top200/1`);
            }
        },
        '/episode/top200/:track': {
            get: (_, { track: track })=>{
                $833ddd79a766fc37$var$loadPlaylist('top200', ()=>{
                    $833ddd79a766fc37$var$trackList.skip(track - 1);
                });
            }
        },
        '/episode/:year/:month/:day': {
            get: (_, { year: year, month: month, day: day })=>{
                router.navigate(`/episode/${year}/${month}/${day}/1`);
            }
        },
        '/episode/:year/:month/:day/:track': {
            get: (_, { year: year, month: month, day: day, track: track })=>{
                $833ddd79a766fc37$var$loadPlaylist(`${year}/${month}/${day}`, ()=>{
                    $833ddd79a766fc37$var$trackList.skip(track - 1);
                });
            }
        },
        '/home': {
            get: ()=>{
                $833ddd79a766fc37$var$player.play(true) //play intro video
                ;
            }
        }
    });
    window.onhashchange = function() {
        router.navigate(window.location.hash);
    };
    // EPISODE/SPECIAL TAB
    $('body').on('click', '.nav .skip-to-year', function(_e) {
        const year = $(this).attr('data-year');
        const anchor = $('a[name=episode-' + year + ']');
        $('#pop-up-container').scrollTop(anchor.position().top);
    });
    $('.sort-by-date').on('click', function(_e) {
        $('#specials').hide();
        $('#episodes').show();
        $('.sort-by-date').parent().addClass('active');
        $('.sort-by-special').parent().removeClass('active');
        $('.skip-to-year-toggle').parent().removeClass('disabled');
    });
    $('.sort-by-special').on('click', function(_e) {
        $('#specials').show();
        $('#episodes').hide();
        $('.sort-by-date').parent().removeClass('active');
        $('.sort-by-special').parent().addClass('active');
        $('.skip-to-year-toggle').parent().addClass('disabled');
    });
    // Load playlist data, then render episodes tabs
    (0, $ecd2f77a879a31aa$export$c0933877973da308)().then((data)=>{
        $('#episodes').empty().append((0, $534e17de79e7dddf$export$2e2bcd8739ae039)(data.playlists));
        $('#specials').empty().append((0, $467385f7f475430f$export$2e2bcd8739ae039)(data.playlists));
        $('#year-dropdown .dropdown-menu').append((0, $cc80b4a83a45e629$export$2e2bcd8739ae039)());
        $('[data-playlist-count]').text(data.playlists.length);
        $833ddd79a766fc37$var$initTooltips();
    });
    // TOP MENU
    $('.episode-button').on('click', function(_e) {
        $833ddd79a766fc37$var$changeTab('episodeList');
    });
    $('.now-playing-button').on('click', function(_e) {
        $833ddd79a766fc37$var$changeTab('nowPlaying');
    });
    $('.player-backward').on('click', function(_e) {
        //trackList.prev()
        if ($833ddd79a766fc37$var$trackList.hasPrev()) router.navigate('/episode/' + $833ddd79a766fc37$var$currentPlaylist + '/' + $833ddd79a766fc37$var$trackList.getPosition());
    });
    $('.player-forward').on('click', function(_e) {
        if ($833ddd79a766fc37$var$trackList.hasNext()) router.navigate('/episode/' + $833ddd79a766fc37$var$currentPlaylist + '/' + ($833ddd79a766fc37$var$trackList.getPosition() + 2));
    });
    $('.player-pause').on('click', function(_e) {
        $833ddd79a766fc37$var$player.togglePause();
    });
    if (!document.fullscreenEnabled) $('.player-fullscreen').hide();
    else $('.player-fullscreen').on('click', function(_e) {
        if (document.fullscreenElement) document.exitFullscreen();
        else document.documentElement.requestFullscreen({
            navigationUI: 'hide'
        });
    });
    ///// EVENTS /////
    $833ddd79a766fc37$var$trackList.on('change', $833ddd79a766fc37$var$onTrackChange);
    $833ddd79a766fc37$var$trackList.on('finished', ()=>$833ddd79a766fc37$var$changeTab('episodeList'));
    $833ddd79a766fc37$var$sourceList.on('change', $833ddd79a766fc37$var$onSourceChange);
    $833ddd79a766fc37$var$sourceList.on('loadError', $833ddd79a766fc37$var$onSourceListLoadFailed);
    $833ddd79a766fc37$var$player.on('error', (error)=>{
        console.log('Failed to load video', $833ddd79a766fc37$var$sourceList.current()?.url, error);
        $833ddd79a766fc37$var$sourceList.setCurrentError();
        const result = $833ddd79a766fc37$var$sourceList.next() // load next alt sources, until we have tried them all
        ;
        if (result === null) $833ddd79a766fc37$var$trackList.next();
    });
    $833ddd79a766fc37$var$player.on("ended", ()=>$833ddd79a766fc37$var$trackList.next());
    $833ddd79a766fc37$var$player.on("paused", ()=>{
        $('.player-pause i').removeClass().addClass('icon-play');
    });
    $833ddd79a766fc37$var$player.on("playing", ()=>{
        $('.player-pause i').removeClass().addClass('icon-pause');
    });
    ///// KEYBOARD SHORTCUTS /////
    $(document).on('keyup', function(e) {
        const key = e.which;
        //Left arrow
        if (key == 37) $833ddd79a766fc37$var$trackList.prev();
        //Right arrow
        if (key == 39) $833ddd79a766fc37$var$trackList.next();
        //Space bar
        if (key == 32) $833ddd79a766fc37$var$player.togglePause();
        return true;
    });
    // Prevent default (i.e. scrolling) for the left and right arrow keys
    $(document).on('keydown', function(e) {
        const key = e.which;
        if (key == 37 || key == 39) {
            e.preventDefault();
            return false;
        }
        return true;
    });
    router.start('/home');
};
const $833ddd79a766fc37$var$loadPlaylist = async function(id, callback) {
    if (typeof id == 'undefined') throw "RageAgain.loadPlaylist() id is undefined.";
    const path = id + '.json';
    if ($833ddd79a766fc37$var$currentPlaylist == id) {
        if (typeof callback === 'function') callback($833ddd79a766fc37$var$currentPlaylist);
        return;
    }
    try {
        const data = await (0, $ecd2f77a879a31aa$export$b9347112ad6b5fab)(path);
        $('#fullscreen-loader').hide();
        if (!data || !data.tracks) {
            alert('Failed to load selected playlist. No tracks found.');
            return;
        }
        $833ddd79a766fc37$var$currentPlaylist = id;
        $833ddd79a766fc37$var$trackList.clear();
        $833ddd79a766fc37$var$trackList.add(data.tracks);
        if (typeof callback === 'function') callback($833ddd79a766fc37$var$currentPlaylist);
        $('a span.now-playing-label').remove();
        $('a[data-playlist_id="' + id + '"]').append('<span class="label label-important now-playing-label">p</span>');
        $833ddd79a766fc37$var$changeTab('nowPlaying');
    } catch (error) {
        console.error('Failed to load playlist', error);
    }
};
const $833ddd79a766fc37$var$initTooltips = ()=>{
    $(document).tooltip({
        selector: 'a[rel=tooltip]',
        placement: function(_tooltip, target) {
            return $(target).attr('data-placement') || 'top';
        },
        trigger: 'manual'
    });
    const checkTooltipOffset = ()=>{
        const leftOffset = $('body').children('.tooltip').offset()?.left;
        if ((leftOffset ?? 0) < 0) $('body').children('.tooltip').offset({
            left: 0
        });
    };
    $('a[rel=tooltip]').on('mouseenter', function(e) {
        $(this).tooltip('show');
        checkTooltipOffset();
        setTimeout(checkTooltipOffset, 100);
        e.preventDefault();
        e.stopImmediatePropagation();
    });
    $('a[rel=tooltip]').on('mouseleave', function(_e) {
        $(this).tooltip('hide');
    });
};
const $833ddd79a766fc37$var$onTrackChange = function({ current: curTrack }) {
    $833ddd79a766fc37$var$sourceList.load(curTrack);
    $('#nav-right').fadeIn();
    $('.artist').text(curTrack.artist);
    $('.track').text(curTrack.song);
    document.title = `${curTrack.song} by ${curTrack.artist} | Rage Replay`;
    if (curTrack.label) $('.tracklabel').text('(' + curTrack.label + ')');
    else $('.tracklabel').text('');
    $('#now-playing-info').hide().delay(1500).fadeIn('slow').delay(8000).fadeOut();
    if ($833ddd79a766fc37$var$player.getState() == YT.PlayerState.UNSTARTED) $833ddd79a766fc37$var$player.play();
};
const $833ddd79a766fc37$var$onSourceListLoadFailed = function() {
    console.log('onSourceListLoadFailed');
    const current = $833ddd79a766fc37$var$trackList.current();
    // Remove this track and load next one
    // @TODO notify user that track failed to load
    if (current) {
        console.log(`No sources available. Removing track...${$833ddd79a766fc37$var$trackList.current()?.song} - ${$833ddd79a766fc37$var$trackList.current()?.artist}`);
        $833ddd79a766fc37$var$trackList.remove(current);
    }
    $833ddd79a766fc37$var$trackList.next();
};
const $833ddd79a766fc37$var$onSourceChange = function() {
    console.log('onSourceChange');
    if ($833ddd79a766fc37$var$sourceList.current()?.url) $833ddd79a766fc37$var$player.loadVideoByUrl($833ddd79a766fc37$var$sourceList.current().url);
};
const $833ddd79a766fc37$var$changeTab = function(tabName) {
    if (tabName == 'episodeList') {
        $('header #nav-left a').removeClass('active');
        $('.episode-button').addClass('active');
        $('#overlay').fadeIn();
        $('#episode-container').show();
        $('#pop-up-container').show();
    } else if (tabName == 'nowPlaying') {
        $('header #nav-left a').removeClass('active');
        $('.now-playing-button').addClass('active');
        $('#overlay').fadeOut();
        $('#episode-container').hide();
        $('#pop-up-container').hide();
    }
};
function $833ddd79a766fc37$export$2e2bcd8739ae039() {
    if (!!window.$ && !!window.Simrou) {
        $(()=>$833ddd79a766fc37$var$init());
        return;
    }
    const timer = setInterval(()=>{
        if (!!window.$ && !!window.Simrou) {
            clearInterval(timer);
            $(()=>$833ddd79a766fc37$var$init());
        }
    }, 100);
}


(0, $833ddd79a766fc37$export$2e2bcd8739ae039)();


//# sourceMappingURL=index.c032fc2b.js.map
